import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  readonly sidebarVisible = signal(true);
  readonly mobileSidebarVisible = signal(false);

  toggleDesktopSidebar(): void {
    this.sidebarVisible.update((v) => !v);
  }

  toggleMobileSidebar(): void {
    this.mobileSidebarVisible.update((v) => !v);
  }

  closeMobileSidebar(): void {
    this.mobileSidebarVisible.set(false);
  }
}
